// Modules
import { Typography } from "antd";

// Components
import ContainerDiv from "components/atoms/ContainerDiv/ContainerDiv";

// Type definitions
export type TextProps = {
	classes?: string;
	textContent?: string;
	style?: React.CSSProperties;
};

const Text = ({ classes, textContent, style }: TextProps): JSX.Element => {
	return (
		<Typography.Text className={classes} style={style}>
			<ContainerDiv testid="text">{textContent}</ContainerDiv>
		</Typography.Text>
	);
};

export default Text;
